<div [ngClass]="singleLine ? 'c-rich-text--single-line' : 'pb-40'">
  <ng-container *ngIf="templateVariables.length > 0">
    <ckeditor
      id="editor"
      [editor]="Editor"
      [(ngModel)]="value"
      (ngModelChange)="value = $event; onChange($event)"
      (ready)="onEditorReady($event)"
      [config]="editorConfig"
      [data]="String(value)"
    ></ckeditor>
  </ng-container>
</div>
